var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaggerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.8,
    height: 55.4,
    viewBox: "0 0 65.8 55.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M56.1,66.1H22.9a5.8,5.8,0,0,0,0,11.6H56.1a5.8,5.8,0,0,0,0-11.6ZM24.6,74.3A2.4,2.4,0,1,1,27,71.9,2.5,2.5,0,0,1,24.6,74.3Zm9.9,0a2.4,2.4,0,1,1,2.4-2.4A2.433,2.433,0,0,1,34.5,74.3Zm10,0a2.4,2.4,0,1,1,2.4-2.4A2.433,2.433,0,0,1,44.5,74.3Zm9.9,0a2.4,2.4,0,1,1,2.4-2.4A2.369,2.369,0,0,1,54.4,74.3Zm24.8-24a1.02,1.02,0,0,0,.5-.8,1,1,0,0,0-1-1h-.6L71.6,26a2.389,2.389,0,0,0,.5-1.4,2.263,2.263,0,0,0-2.3-2.3H65.5a2.529,2.529,0,0,0-2.1,1.3L52.3,28,44.4,43.5H42.5l-1.7,1.2v9.4h-1V52H31.5v2.1H30.2V52.4a1.763,1.763,0,0,0-.8-1.5V46.8a1,1,0,0,0-2,0V51a1.763,1.763,0,0,0-.8,1.5v1.7H22V64.4H57.8V51.1L53,43.5H51.6l3.6-10,10.6-6.7h2c1.6,4.2,6.1,17.9,7.4,21.7a.9.9,0,0,0-.9.9.961.961,0,0,0,.8.9L70.8,59l9.9-1.5,2.2-3.9Zm-24,1.4v4.7H43.3v-10H52Z",
    transform: "translate(-17.1 -22.3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggerIcon);
export default __webpack_public_path__ + "static/media/BaggerIcon.b6f3d6b6d44680a60df630b04a7f062f.svg";
export { ForwardRef as ReactComponent };